const adminMobileNumber = "9098352100"
const adminEmail = "amar212game@gmail.com"

export { adminMobileNumber, adminEmail }